import { DatePicker, Select } from "antd";
import { FormCol } from "components/UI/Form/FormCol";
import { FormGrid } from "components/UI/Form/FormGrid";
import { AffiliateBillingSelectSearchable } from "components/UI/Selects/AffiliateBillingSelectSearchable/AffiliateBillingSelectSearchable.tsx";
import { PartnerSelectSearchable } from "components/UI/Selects/PartnerSelectSearchable/PartnerSelectSearchable";
import { usePaldockTranslation } from "hooks/usePaldockTranslation";
import { FC } from "react";
import { Control } from "react-hook-form";
import { FormItem } from "react-hook-form-antd";

import { OfferEditGeneralFormData } from "../formSchema";

interface SettingsSectionProps {
    control: Control<OfferEditGeneralFormData>;
    access: string | undefined;
}

export const SettingsSection: FC<SettingsSectionProps> = ({ control, access }) => {
    const { t: tF } = usePaldockTranslation("forms.offer-general-edit");
    const { t: tFields } = usePaldockTranslation("forms.general-fields");
    const { t: tC } = usePaldockTranslation("common");

    return (
        <FormCol>
            <FormGrid cols={3}>
                <FormItem control={control} name="status" label={tFields("status.label")} required>
                    <Select
                        options={[
                            { label: tC("active"), value: "enabled" },
                            { label: tC("inactive"), value: "disabled" },
                        ]}
                    />
                </FormItem>
                <FormItem control={control} name="enabled_from" label={tFields("active_from_not_required.label")}>
                    <DatePicker className="w-full" />
                </FormItem>
                {/* <FormItem control={control} name="integrations" label={tFields("integrations.label")}>
                    <IntegrationSelectSearchable mode="multiple" allowClear />
                </FormItem> */}
                <FormItem
                    control={control}
                    name="affiliate_billing"
                    label={tFields("affiliate_billing.label")}
                    required
                >
                    <AffiliateBillingSelectSearchable includeTenantSettingOption />
                </FormItem>
            </FormGrid>
            <FormGrid cols={3}>
                <FormItem control={control} name="access" label={tF("fields.access.label")} required>
                    <Select
                        options={[
                            { label: tF("fields.access.options.public"), value: "public" },
                            { label: tF("fields.access.options.restricted"), value: "restricted" },
                            { label: tF("fields.access.options.invite_only"), value: "private" },
                        ]}
                    />
                </FormItem>
                {(access === "private" || access === "restricted") && (
                    <FormItem
                        control={control}
                        name="partners"
                        label={tF("fields.partners.label")}
                        className="col-span-2"
                    >
                        <PartnerSelectSearchable mode="multiple" allowClear />
                    </FormItem>
                )}
            </FormGrid>
        </FormCol>
    );
};
